module.exports = __webpack_public_path__ + "img/header_new4.8d0241b6.png";